module.exports = __webpack_public_path__ + "img/Gasmachine3.3680fd2f.png";